'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import Cookies from 'js-cookie';

const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_SITE_DOMAIN || '';
const COOKIE_PATH = '/'; 

const MAIN_COOKIE = process.env.NEXT_PUBLIC_COOKIE_NAME || 'cr_prod_token';
const REFRESH_COOKIE = process.env.NEXT_PUBLIC_REFRESH_COOKIE_NAME || 'cr_prod_refresh_token';
const EXPIRE_COOKIE = process.env.NEXT_PUBLIC_EXPIRE_COOKIE_NAME || 'cr_prod_expire_token';

export default function TokenGuard() {
  const router = useRouter();

  useEffect(() => {
    const refreshToken = Cookies.get(REFRESH_COOKIE);
    const authToken = Cookies.get(MAIN_COOKIE);
    const expireToken = Cookies.get(EXPIRE_COOKIE);

    if (authToken && (!refreshToken || !expireToken )) {
      const removeOptions = {
        domain: COOKIE_DOMAIN,
        path: COOKIE_PATH,
      };
      Cookies.remove(MAIN_COOKIE, removeOptions);
      Cookies.remove(REFRESH_COOKIE, removeOptions);
      Cookies.remove(EXPIRE_COOKIE, removeOptions);

      router.replace('/');
    }
  }, []);

  return null;
}
